// extracted by mini-css-extract-plugin
export default {"badgeClamp":"ActionPlansByReportPage_badgeClamp__rsMJk","chipContainer":"ActionPlansByReportPage_chipContainer__l4X8i","mobileH3":"ActionPlansByReportPage_mobileH3__GIzLf"};